/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soonki Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 26 2023
 **/

import { GroupPopoverType, SinglePopoverType } from "@/frameworks/core/hooks";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const popoverListAtom = atom<(SinglePopoverType | GroupPopoverType)[]>([]);
export const displayedPopoversAtom = atomWithStorage<string[]>("displayedPopovers", []);

export default popoverListAtom;
